<template>
  <li class="history-item">
    <div class="item-inner">
      <Item v-if="history.type === 0" role="li" class="item" type="reward" :nums="history.item_num" :imgSrc="history.item_img" />
      <div class="item-desc" v-else>
        <div class="item-desc-gift"></div>
      </div>
      <div class="item-name">
        <p v-marquee>
          <span class="bebas-font">{{ history.type === 0 ? history.item_name : $bus.transify['LUCKY_REFRESH']}}</span>
        </p>
      </div>
    </div>
    <div class="history-cost">
      <p class="cost">
        <i class="diamond"></i>
        <span class="gem-nums bebas-font" :class="history.cost === 0 ? 'free': ''">
          {{history.cost === 0 ? $bus.transify['LUCKY_FREE'] : history.cost}}
        </span>
      </p>
    </div>
    <div class="history-discount">
      <span class="history-discount-text bebas-font" v-if="history.discount_type !== 0 && history.type !== 1">{{ history.discount + '%' + $bus.transify['LUCKY_OFF'] }}</span>
    </div>
    <div class="history-time bebas-font">{{ formateTime(history.created) }}</div>
  </li>
</template>

<script>
import Item from '@/components/common/Item.vue'
// import ffMark from '@/components/common/Mark.vue'
import { getTime } from '@/utils/assist'
export default {
  props: {
    history: Object
  },
  components: {
    Item
  },
  methods: {
    formateTime (time) {
      return getTime(time)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-item {
  @include px2res(height, 126);
  @include px2res(line-height, 27);
  @include px2res(font-size, 24);
  @include flexrc;
  color: #fff;
  justify-content: space-around;
  width: 100%;
  position: relative;
  white-space: normal;
  text-transform: uppercase;
  .item-inner {
    @include px2res(width, 350);
    @include flexrc;
    justify-content: space-around;
  }
  .item.light {
    animation: none !important;
    box-shadow: none !important;
  }
  .item {
    @include px2res(width, 90);
    @include px2res(height, 90);
  }
  .item-desc {
    @include flexrc;
    @include px2res(width, 90);
    @include px2res(height, 90);
    .item-desc-gift {
      @include px2res(width, 47);
      @include px2res(height, 50);
    }
  }
  .item-name {
    @include px2res(width, 120);
    @include px2res(height, 34);
    @include px2res(margin, 0, 40, 0, 0);
    overflow: hidden;
    p {
      overflow: hidden;
      text-align: center;
      white-space: nowrap;
    }
  }
  .history-cost {
    @include flexrc;
    justify-content: flex-start;
    @include px2res(width, 120);
    font-weight: 500;
    white-space: nowrap;
    .cost {
      @include flexrc;
      position: relative;
      align-items: flex-end;
      text-transform: uppercase;
      @include px2res(font-size, 24);
      .diamond {
        @include px2res(width, 30);
        @include px2res(height, 27);
        @include px2res(margin-right, 10);
      }
      .gem-nums.free {
        @include px2res(font-size, 20);
      }
    }
  }

  .history-discount {
    @include flexrc;
    justify-content: flex-start;
    @include px2res(width, 120);
    white-space: nowrap;
    .history-discount-text {
      @include px2res(font-size, 24);
    }
  }
  .history-time {
    text-align: center;
    @include px2res(width, 250);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/history/item.vue